import Swiper from 'swiper';

$(window).scroll(function () {
  if ($('.wrapper-main').hasClass('isSticky')) {
    if ($(this).scrollTop() > 1) {
      $('.wrapper-main').addClass('sticky');
    } else {
      $('.wrapper-main').removeClass('sticky');
    }
  }
});

$(document).ready(function () {
  if (document.querySelector('.home-swiper')) {
    const _swiper = new Swiper(document.querySelector('.home-swiper'), {
      navigation: {
        nextEl: document.querySelector('.home-swiper__next'),
        prevEl: document.querySelector('.home-swiper__prev')
      },
      autoplay: {
        delay: 6000
      },
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true
    });
  }

  $('.list-item-carousel').each(function () {
    $(this).owlCarousel({
      autoHeight: false,
      dots: false,
      items: 4,
      lazyLoad: false,
      loop: false,
      margin: 10,
      mouseDrag: true,
      nav: true,
      navClass: [
        'owl-single-item-nav left carousel-control list-control-special',
        'owl-single-item-nav right carousel-control list-control-special'
      ],
      navContainerClass: '',
      navText: [
        '<i class="owl-single-item-control fa fa-angle-left" aria-hidden="true"></i>',
        '<i class="owl-single-item-control fa fa-angle-right" aria-hidden="true"></i>'
      ],
      smartSpeed: 350,
      responsive: {
        // breakpoint from 0 up
        0: {
          items: 1,
          slideBy: 1
        },
        // breakpoint from 544 up
        544: {
          items: 2,
          slideBy: 2
        },
        // breakpoint from 768 up
        768: {
          items: 4,
          slideBy: 4
        }
      },
      onTranslated: function (elem) {
        // $('.lazy').lazyload();
      }
    });
    $(this).addClass('owl-loaded');
  });

  $('.single-item-carousel').each(function () {
    $(this).owlCarousel({
      autoHeight: true,
      dots: true,
      items: 6,
      lazyLoad: false,
      loop: false,
      margin: 0,
      mouseDrag: true,
      nav: true,
      navClass: [
        'owl-single-item-nav left carousel-control list-control-special',
        'owl-single-item-nav right carousel-control list-control-special'
      ],
      navContainerClass: '',
      navText: [
        '<i class="owl-single-item-control fa fa-angle-left" aria-hidden="true"></i>',
        '<i class="owl-single-item-control fa fa-angle-right" aria-hidden="true"></i>'
      ],
      smartSpeed: 350,
      responsive: {
        // breakpoint from 0 up
        0: {
          items: 1,
          slideBy: 1
        },
        // breakpoint from 544 up
        544: {
          items: 2,
          slideBy: 2
        },
        // breakpoint from 768 up
        768: {
          items: 4,
          slideBy: 4
        },
        1025: {
          items: 6,
          slideBy: 6
        }
      },
      onTranslated: function (elem) {
        // $('.lazy').lazyload();
      }
    });
  });

  $(function () {
    const header = $('.noscroll');

    $(window).scroll(function () {
      const scroll = $(window).scrollTop();

      if (scroll >= 50) {
        header.removeClass('noscroll').addClass('scroll');
      } else {
        header.removeClass('scroll').addClass('noscroll');
      }
    });
  });
});
